import script from "./AdvertisersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertisersTable.vue?vue&type=script&setup=true&lang=js"

import "./AdvertisersTable.vue?vue&type=style&index=0&id=24b7bb2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b7bb2a"]])

export default __exports__